/**
 * Search 도메인 Adapter Hook Wrapper
 *
 * Adapter를 사용하여 검색 관련 쿼리를 처리합니다.
 */

import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {SEARCH_QUERY_KEY_MAP} from '../api/search/constant';
import {searchFactory} from '../factory/searchFactory';

// ============================================
// useSearchAutoCompleteQuery
// ============================================

export function useSearchAutoCompleteQuery(
  ...args: Parameters<typeof searchFactory.searchAutoComplete>
) {
  return useQuery(searchFactory.searchAutoComplete(...args));
}

useSearchAutoCompleteQuery.getKey = (
  ...args: Parameters<typeof SEARCH_QUERY_KEY_MAP.searchAutoComplete>
) => [...SEARCH_QUERY_KEY_MAP.searchAutoComplete(...args)];

// ============================================
// useSearchMainQuery
// ============================================

export function useSearchMainQuery(
  ...args: Parameters<typeof searchFactory.searchMain>
) {
  return useQuery(searchFactory.searchMain(...args));
}

useSearchMainQuery.getKey = (
  ...args: Parameters<typeof SEARCH_QUERY_KEY_MAP.searchMain>
) => [...SEARCH_QUERY_KEY_MAP.searchMain(...args)];

// ============================================
// useInfiniteSearchKeywordQuery
// ============================================

export function useInfiniteSearchKeywordQuery(
  ...args: Parameters<typeof searchFactory.infiniteSearchKeyword>
) {
  return useInfiniteQuery(searchFactory.infiniteSearchKeyword(...args));
}

useInfiniteSearchKeywordQuery.getKey = (
  ...args: Parameters<typeof SEARCH_QUERY_KEY_MAP.infiniteSearchKeyword>
) => [...SEARCH_QUERY_KEY_MAP.infiniteSearchKeyword(...args)];

// ============================================
// useInfiniteSearchThemeKeywordQuery
// ============================================

export function useInfiniteSearchThemeKeywordQuery(
  ...args: Parameters<typeof searchFactory.infiniteSearchThemeKeyword>
) {
  return useInfiniteQuery(searchFactory.infiniteSearchThemeKeyword(...args));
}

useInfiniteSearchThemeKeywordQuery.getKey = (
  ...args: Parameters<typeof SEARCH_QUERY_KEY_MAP.infiniteSearchThemeKeyword>
) => [...SEARCH_QUERY_KEY_MAP.infiniteSearchThemeKeyword(...args)];
